import styled from 'styled-components';

export const IssueSummaryTextStyled = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const IssueTextStyled = styled.div`
  display: flex;
  :hover {
    text-decoration: underline;
  }
`;

export const IssueSummaryStyled = styled.div`
  padding-right: 8px;
  max-width: 219px;
`;

export const IssueIconStyled = styled.img`
  display: flex;
  padding-left: 4px;
  height: 16px;
  width: 16px;
`;

export const IssueContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const IssueKeyWrapperStyled = styled.div`
  display: flex;
`;

export const IssueKeyStyled = styled.div`
  font-weight: bold;
  padding-left: 8px;
  padding-right: 8px;
  color: var(--ds-text-subtle, var(--ds-fb-text-subtle));
  width: fit-content;
  min-width: max-content;
`;

export const IssueStatusStyled = styled.div`
  height: 16px;
`;
